module.exports = __webpack_public_path__ + "img/logo4.f6807754.png";